export default __webpack_public_path__ + "static/media/10 - DaySpring Intro.784ecb9a.mp3";